import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65bc3f0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "TableShop"
}
const _hoisted_2 = { class: "TableShop_Top" }
const _hoisted_3 = { class: "TableShop_Total" }
const _hoisted_4 = { class: "TableShop_Middle" }
const _hoisted_5 = { class: "TableShop_FrameTable" }
const _hoisted_6 = { class: "TableShop_Bottom" }
const _hoisted_7 = {
  key: 1,
  class: "TableShop_Message"
}

import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import BtnGreenSmall from "../components/atoms/button/BtnGreenSmall.vue";
import BtnOrange from "../components/atoms/button/BtnOrange.vue";
import SelectNormal from "../components/atoms/select/SelectNormal.vue";
import ModalTableShop from "../components/modal/ModalTableShop.vue";
import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { Notyf } from "notyf";

export type ResItems = {
  availableAmount: number | null;
  bansen: string;
  hold: boolean;
  holdSum: number | null;
  hontaiPrice: number | null;
  janCd: string | null;
  juchuKbn: number | null;
  quantity: number | null;
  requester: string | null;
  salesCd: number;
  salesName: string | null;
  shinagireSum: number | null;
  syosiCd: string | null;
  title: string | null;
  toritugiCd: string;
  toritugiMei: string;
  toritugiSyotenCd: string;
  toritugiSyotenMei: string;
  totalQuantity: number;
  totalType: number;
  tanzkau: string;
};
export interface Items extends ResItems {
  No: number;
}

// データ取得-----------------------------------------------------------------

export default /*#__PURE__*/_defineComponent({
  __name: 'TableShop',
  setup(__props) {

const notyf = new Notyf();
const store = useStore();
const userInfo = store.getters["login/getUserData"];

const headers = [
  { title: "No" },
  { title: "取次" },
  { title: "書店コード" },
  { title: "番線" },
  { title: "書店名" },
  { title: "合計点数" },
  { title: "合計冊数" },
  { title: "注文内容表示" },
  { title: "登録" },
  { title: "削除" },
];
let items = ref([] as Items[]);
const getMultiItems = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/chumon/multi/cartData`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    items.value.splice(0);
    res.data.forEach((data: ResItems, index: number) => {
      items.value.push({ No: index + 1, ...data });
    });
  } catch (error) {
    console.log(error);
    alert("カートデータを取得できませんでした");
  }
};
getMultiItems();

// モーダル関連-------------------------------------------------------------
// 注文内容表示
const sampleModalVisible = ref(false);
const selectedItem = ref({
  toritugiCd: "",
  toritugiSyotenCd: "",
  bansen: "",
});
const showSampleModal = (item: Items) => {
  selectedItem.value.toritugiCd = item.toritugiCd;
  selectedItem.value.toritugiSyotenCd = item.toritugiSyotenCd;
  selectedItem.value.bansen = item.bansen;
  sampleModalVisible.value = true;
};
const closeSampleModal = () => {
  selectedItem.value.toritugiCd = "";
  selectedItem.value.toritugiSyotenCd = "";
  selectedItem.value.bansen = "";
  sampleModalVisible.value = false;
};
const updatedCart = () => {
  closeSampleModal();
  getMultiItems();
};

// 削除関連-----------------------------------------------------------------
const deleteItem = async (item: Items) => {
  if (
    confirm(`「${item.toritugiSyotenMei}」の注文を削除してもよろしいですか？`)
  ) {
    try {
      const sendData = [
        {
          hanmotoCd: userInfo.hanmotoCd,
          userId: userInfo.userId,
          janCd: item.janCd,
          quantity: item.quantity,
          toritugiCd: item.toritugiCd,
          toritugiSyotenCd: item.toritugiSyotenCd,
          tanzaku: item.tanzkau,
          bansen: item.bansen,
          juchuKbn: item.juchuKbn,
          isUpdate: true,
          isHold: item.hold,
        },
      ];
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/multi/deleteEachSyotenCartData`,
        sendData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      notyf.success(`「${item.toritugiSyotenMei}」の注文を削除しました`);
      getMultiItems();
    } catch (error) {
      console.log(error);
      alert("削除に失敗しました");
    }
  }
};
const deleteAllItems = async () => {
  if (confirm(`全ての注文を削除してもよろしいですか？`)) {
    try {
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/multi/deleteAllSyotenCartData`,
        "",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      notyf.success(`全ての注文を削除しました`);
      getMultiItems();
    } catch (error) {
      console.log(error);
      alert("削除に失敗しました");
    }
  }
};

// 上部表紙合計関連--------------------------------------------------------
const countSyoten = computed(() => {
  return items.value.length;
});
const countTensuu = computed(() => {
  let totalTensuu = 0;
  items.value.forEach((item) => {
    totalTensuu += item.totalType;
  });
  return totalTensuu;
});
const countSassuu = computed(() => {
  let totalSassuu = 0;
  items.value.forEach((item) => {
    totalSassuu += item.totalQuantity;
  });
  return totalSassuu;
});
// 登録関連----------------------------------------------------------------
// 個別登録
const registerEach = async (item: Items) => {
  try {
    const sendData = [
      {
        hanmotoCd: userInfo.hanmotoCd,
        userId: userInfo.userId,
        toritugiCd: item.toritugiCd,
        toritugiSyotenCd: item.toritugiSyotenCd,
        bansen: item.bansen,
      },
    ];
    await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/multi/registerMultiJuchu`,
      sendData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success("登録しました");
    getMultiItems();
  } catch (error) {
    console.log(error);
    alert("登録できませんでした");
  }
};
// 一括登録
const registerAll = async () => {
  try {
    const sendData = [
      {
        hanmotoCd: "",
        userId: -1,
        toritugiCd: "",
        toritugiSyotenCd: "",
        bansen: "",
      },
    ];
    sendData.splice(0);
    items.value.forEach((item) => {
      sendData.push({
        hanmotoCd: userInfo.hanmotoCd,
        userId: userInfo.userId,
        toritugiCd: item.toritugiCd,
        toritugiSyotenCd: item.toritugiSyotenCd,
        bansen: item.bansen,
      });
    });
    await axios.post(
      `${store.getters["getBaseUrl"]}/chumon/multi/registerMultiJuchu`,
      sendData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success("登録しました");
    getMultiItems();
  } catch (error) {
    console.log(error);
    alert("登録できませんでした");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(items).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (sampleModalVisible.value)
            ? (_openBlock(), _createBlock(ModalTableShop, {
                key: 0,
                toritugiCd: selectedItem.value.toritugiCd,
                toritugiSyotenCd: selectedItem.value.toritugiSyotenCd,
                bansen: selectedItem.value.bansen,
                onClose: closeSampleModal,
                onUpdatedCart: updatedCart,
                onDeleteItem: getMultiItems
              }, null, 8, ["toritugiCd", "toritugiSyotenCd", "bansen"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, "書店数合計：" + _toDisplayString(countSyoten.value.toLocaleString()) + "店", 1),
              _createElementVNode("p", null, "点数合計：" + _toDisplayString(countTensuu.value.toLocaleString()) + "点", 1),
              _createElementVNode("p", null, "冊数合計：" + _toDisplayString(countSassuu.value.toLocaleString()) + "冊", 1)
            ]),
            _createVNode(BtnGreenSmall, { onClick: deleteAllItems }, {
              default: _withCtx(() => [
                _createTextVNode("すべて削除")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header, index) => {
                    return _createElementVNode("th", { key: index }, [
                      _createElementVNode("p", null, _toDisplayString(header.title), 1)
                    ])
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.No), 1),
                    _createElementVNode("td", null, _toDisplayString(item.toritugiMei), 1),
                    _createElementVNode("td", null, _toDisplayString(item.toritugiSyotenCd), 1),
                    _createElementVNode("td", null, _toDisplayString(item.bansen), 1),
                    _createElementVNode("td", null, _toDisplayString(item.toritugiSyotenMei), 1),
                    _createElementVNode("td", null, _toDisplayString(item.totalType), 1),
                    _createElementVNode("td", null, _toDisplayString(item.totalQuantity), 1),
                    _createElementVNode("td", null, [
                      _createVNode(BtnOrange, {
                        onClick: ($event: any) => (showSampleModal(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("注文内容表示")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(BtnGreen, {
                        onClick: ($event: any) => (registerEach(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("注文確定")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "TableShop_FrameTable_Icon",
                        icon: "trash-can",
                        onClick: ($event: any) => (deleteItem(item))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BtnGreen, { onClick: registerAll }, {
              default: _withCtx(() => [
                _createTextVNode("一括登録")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(items).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 書誌情報はありません。 "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})